import React, { useState } from 'react';
import './MSMELoan.css';
import MSMELoanBanner from '../images/msme-loan-banner.png';
import MSMELoanInner from '../images/MSME-Loan.jpeg';

const MSMELoan = () => {
  const [activeTab, setActiveTab] = useState('eligibility');

  return (
    <div className="msme-loan-page" style={{ backgroundImage: `url(${MSMELoanInner})` }}>
      {/* Banner Section */}
      <section className="msme-loan-banner">
        <div className="msme-banner-container">
          <div className="msme-banner-left">
            <div className="msme-banner-image" style={{ backgroundImage: `url(${MSMELoanBanner})` }}>
              <div className="msme-image-overlay">
                <h1 className="msme-banner-title">MSME SECURED LOAN</h1>
              </div>
            </div>
          </div>
          <div className="msme-banner-right">
            <div className="msme-banner-content">
              <h2 className="msme-banner-subtitle">EMPOWER YOUR BUSINESS WITH OUR FLEXIBLE MSME LOANS</h2>
              <p className="msme-banner-description">
                Our company specializes in providing tailored MSME loans to support small and medium enterprises in their growth journey. With flexible terms and quick approval processes, we empower businesses to access the capital they need for expansion, innovation, and operational efficiency. Committed to fostering entrepreneurship, we offer personalized service and expert guidance to help businesses thrive in a competitive landscape.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Features/Benefits Section */}
      <section className="msme-features-section">
        <div className="msme-features-container">
          <h2 className="msme-features-heading">FEATURES/BENEFITS</h2>
          <div className="msme-features-content">
            <div className="msme-features-image-wrapper">
              <img src={MSMELoanInner} alt="MSME Loan Features" className="msme-features-image" />
            </div>
            <div className="msme-features-list">
              <div className="msme-feature-item">
                <h3 className="msme-feature-title">LOAN TENURE</h3>
                <p className="msme-feature-description">Convenient door-to-door tenor of up to 7 years for your MSME loan, tailored to your eligibility and business needs.</p>
              </div>
              <div className="msme-feature-item">
                <h3 className="msme-feature-title">MAXIMUM LOAN AMOUNT</h3>
                <p className="msme-feature-description">Access flexible MSME loans of up to Rs. 10 Lakh to fuel your business growth and innovation.</p>
              </div>
              <div className="msme-feature-item">
                <h3 className="msme-feature-title">ACCESSIBILITY</h3>
                <p className="msme-feature-description">First-time borrowers are welcome to apply, making it easier for new entrepreneurs to access the financial support they need.</p>
              </div>
              <div className="msme-feature-item">
                <h3 className="msme-feature-title">CUSTOMIZABLE REPAYMENT OPTIONS</h3>
                <p className="msme-feature-description">Benefit from a flexible repayment schedule with multiple options to suit your cash flow and financial needs.</p>
              </div>
              <div className="msme-feature-item">
                <h3 className="msme-feature-title">CASH FLOW-BASED ASSESSMENT</h3>
                <p className="msme-feature-description">We accept informal income documents, making it easier for you to secure financing without traditional paperwork.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Flexible Repayment Options Section */}
      <section className="msme-repayment-section">
        <div className="msme-repayment-container">
            <div className="msme-repayment-features">
              <div className="msme-repayment-feature-item">
                <div className="msme-repayment-icon">
                  <div className="msme-icon-circle">
                    <span className="msme-rupee-icon">₹</span>
                  </div>
                </div>
                <div className="msme-repayment-feature-content">
                  <h3 className="msme-repayment-feature-title">CUSTOMIZABLE PAYMENT PLANS:</h3>
                  <p className="msme-repayment-feature-description">Choose a repayment schedule that aligns with your business cash flow, allowing for monthly, quarterly, or semi-annual payments based on your revenue cycles.</p>
                </div>
              </div>
              <div className="msme-repayment-feature-item">
                <div className="msme-repayment-icon">
                  <div className="msme-icon-circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" fill="#2c3e50"/>
                    </svg>
                  </div>
                </div>
                <div className="msme-repayment-feature-content">
                  <h3 className="msme-repayment-feature-title">GRACE PERIODS AVAILABLE:</h3>
                  <p className="msme-repayment-feature-description">Benefit from grace periods at the beginning of your loan term, giving you time to stabilize your business before starting repayments.</p>
                </div>
              </div>
              <div className="msme-repayment-feature-item">
                <div className="msme-repayment-icon">
                  <div className="msme-icon-circle">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z" fill="#2c3e50"/>
                      <path d="M9 12h1v1h-1z" fill="#2c3e50"/>
                    </svg>
                  </div>
                </div>
                <div className="msme-repayment-feature-content">
                  <h3 className="msme-repayment-feature-title">PREPAYMENT FLEXIBILITY:</h3>
                  <p className="msme-repayment-feature-description">Enjoy the option to make early repayments without penalties, allowing you to pay off your loan faster if your financial situation improves.</p>
                </div>
              </div>
            </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="msme-advantages-section">
        <div className="msme-advantages-container">
          <h2 className="msme-advantages-heading">ADVANTAGES OF OUR MSME SECURED LOAN FOR YOUR BUSINESS</h2>
          <div className="msme-advantages-divider"></div>
          <p className="msme-advantages-intro">
            We provide digitized secured microloans with easy, paperless onboarding, transparent terms and conditions, and straightforward products that are simple to understand. We offer:
          </p>
          <div className="msme-advantages-list">
            <div className="msme-advantage-item">
              <span className="msme-advantage-arrow">→</span>
              <span className="msme-advantage-text">Repayment Schedules To Align With Your Cash Flow</span>
            </div>
            <div className="msme-advantage-item">
              <span className="msme-advantage-arrow">→</span>
              <span className="msme-advantage-text">Choose A Repayment Period That Suits Your Operational Needs.</span>
            </div>
            <div className="msme-advantage-item">
              <span className="msme-advantage-arrow">→</span>
              <span className="msme-advantage-text">Productivity With Loans Designed For Quick Access To Funds.</span>
            </div>
            <div className="msme-advantage-item">
              <span className="msme-advantage-arrow">→</span>
              <span className="msme-advantage-text">Access Additional Funding Options To Scale Your Business As Needed.</span>
            </div>
          </div>
        </div>
      </section>

      {/* Eligibility and Documents Section */}
      <section className="msme-eligibility-section">
        <div className="msme-eligibility-container">
          <div className="msme-tabs">
            <button 
              className={`msme-tab ${activeTab === 'eligibility' ? 'active' : ''}`}
              onClick={() => setActiveTab('eligibility')}
            >
              Eligibility Criteria
            </button>
            <button 
              className={`msme-tab ${activeTab === 'documents' ? 'active' : ''}`}
              onClick={() => setActiveTab('documents')}
            >
              Required Documents
            </button>
          </div>

          {activeTab === 'eligibility' && (
            <div className="msme-tab-content">
              <ul className="msme-eligibility-list">
                <li>Must be an Indian citizen of age 21 to 55.</li>
                <li>Can offer residential/commercial property (self-owned/owned by family members) as collateral.</li>
                <li>Operate your business from owned premises.</li>
                <li>Must be operating from the same business premises for more than three years.</li>
              </ul>
            </div>
          )}

          {activeTab === 'documents' && (
            <div className="msme-tab-content">
              <h3 className="msme-documents-heading">DOCUMENTATION</h3>
              <ul className="msme-documents-list">
                <li>KYC documents-ID and business registration proofs</li>
                <li>Address proof</li>
                <li>Previous six months bank statement</li>
                <li>ITR copy for the previous three years (if available)</li>
                <li>Digitally signed application form</li>
                <li>Property documents for mortgage</li>
                <li>Papers for the property to be mortgaged</li>
              </ul>
            </div>
          )}
        </div>
      </section>

      {/* Learn More Section */}
      <section className="msme-learn-more-section">
        <div className="msme-learn-more-container">
          <div className="msme-learn-more-content">
            <h2 className="msme-learn-more-title">Learn More About Our Services</h2>
            <p className="msme-learn-more-text">Reach out to us for inquiries.</p>
          </div>
          <a href="/contact" className="msme-contact-btn">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default MSMELoan;

